import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Menu } from "./pages/Menu";
import { MeniItem2 } from "./pages/MenuItem2";


export const App = () => {
  return(
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Menu/>} />
        <Route path="/menu/:id" element={<MeniItem2/>} />
      </Routes>
    </BrowserRouter>
  )
}